// Список объявлений, сохранённый в браузере. Ключ и сроки — здесь, в одном
// месте: их читает раздел «Объявления» и помечает устаревшими публикация в App,
// а тянуть ради этого в главный бандл весь раздел незачем.
export const ACTIVE_ADS_CACHE_KEY = "kl_active_ads_cache_v1";
export const ACTIVE_ADS_CACHE_TTL_MS = 30 * 60 * 1000;
export const ACTIVE_ADS_CACHE_STALE_MAX_MS = 7 * 24 * 60 * 60 * 1000;
// Событие окна: объявление опубликовано. Открытый раздел перечитывает список.
export const AD_PUBLISHED_EVENT = "umbrella:ad-published";

export const activeAdsCacheKey = (ownerId) => `${ACTIVE_ADS_CACHE_KEY}:${String(ownerId || "").trim() || "default"}`;

// После публикации сохранённый список устарел: нового объявления в нём нет.
// Сам список остаётся — раздел откроется сразу, — но при открытии перечитается.
export const markActiveAdsCacheStale = (ownerId) => {
  try {
    const key = activeAdsCacheKey(ownerId);
    const raw = window.localStorage.getItem(key);
    if (!raw) return;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return;
    parsed.savedAt = Math.min(Number(parsed.savedAt || 0), Date.now() - ACTIVE_ADS_CACHE_TTL_MS - 1);
    window.localStorage.setItem(key, JSON.stringify(parsed));
  } catch {
    // Кеш — удобство: не вышло, и список просто обновится по своему сроку.
  }
};
